import React, { useCallback, useContext, useState } from "react";
import { FormBuilderContext } from "../FormBuilderContext";
import "./InputActions.less";
import { Icon_ContentCopy, Icon_Edit, Icon_Trash } from "../../../BP2Components/Icons/icons";
import CreateNewListModal from "../../ListBuilder/ListBuilderView/ListBuilderModals/CreateNewListModal";

interface InputActionsProps {
   onStartEdit: () => void;
   onDelete: () => void;
   onDuplicate?: () => void;
   onNewListCreate?: () => void;
   show?: boolean;
}

const InputActions = ({
   onStartEdit,
   onDelete,
   onDuplicate,
   show = false,
   onNewListCreate,
}: InputActionsProps) => {
   const { previewMode } = useContext(FormBuilderContext);

   if (!show && previewMode) return null;

   const stop = (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
   };

   return (
      <div className={`form-builder-input-actions ${show ? "table" : ""}`}>
         {onDuplicate && (
            <button
               title="Duplikuj formularz"
               className="form-builder-input-action-duplicate"
               onClick={(e) => {
                  stop(e);
                  onDuplicate();
               }}
            >
               <Icon_ContentCopy />
            </button>
         )}

         <button
            title="Usuń formularz"
            className="form-builder-input-action-delete"
            onClick={(e) => {
               stop(e);
               onDelete();
            }}
         >
            <Icon_Trash />
         </button>

         <button
            title="Edytuj formularz"
            className="form-builder-input-action-edit"
            onClick={(e) => {
               stop(e);
               onStartEdit();
            }}
         >
            <Icon_Edit />
         </button>
         <button
            title="Stwórz listę z tego formularza"
            className="form-builder-input-action-edit"
            onClick={onNewListCreate}
         >
            <span className="material-symbols-outlined" style={{ fontSize: "18px" }}>
               article_shortcut
            </span>
         </button>
      </div>
   );
};

export default InputActions;
